import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { GermanFlagIcon, UkFlagIcon } from 'icons';
import { languages } from 'helpers';

const flags: Record<string, (props: { size?: number }) => ReactElement> = {
  en: UkFlagIcon,
  de: GermanFlagIcon,
};

interface LanguageSwitcherProps {
  className?: string;
}

export const LanguageSwitcher = ({ className }: LanguageSwitcherProps) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = (
    i18n.resolvedLanguage ||
    i18n.language ||
    'en'
  ).split('-')[0];

  return (
    <div
      role="group"
      aria-label={String(t('languages.switchLanguage'))}
      onKeyDown={(e) => e.stopPropagation()}
      className={`flex items-center gap-[14px] bg-white border border-[#D5D9DF] rounded-full p-[5px] ${
        className ?? ''
      }`}
    >
      {languages.map((lang) => {
        const Flag = flags[lang.value];
        const isActive = currentLanguage === lang.value;

        if (!Flag) {
          return null;
        }

        return (
          <button
            key={lang.value}
            type="button"
            aria-pressed={isActive}
            aria-label={String(t(lang.labelKey))}
            title={String(t(lang.labelKey))}
            onClick={() => i18n.changeLanguage(lang.value)}
            className={`relative flex items-center justify-center w-[30px] h-[30px] rounded-full border-[2px] transition-all
			after:content-[''] after:absolute after:-inset-[9px]
			${
        isActive
          ? 'border-[#2E435F]'
          : 'border-transparent opacity-40 grayscale hover:opacity-100 hover:grayscale-0'
      }`}
          >
            <Flag size={23} />
          </button>
        );
      })}
    </div>
  );
};
